module.exports = __webpack_public_path__ + "static/media/bg_light_blue.2a504c52.png";